// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1kaKV","range":"MonthRangeSwitch_range__3hvuq","disabled":"MonthRangeSwitch_disabled__11y_c"};